import React from "react";


import NavBarNew from "./NavBarNew";
import HeroSectionPatient from "./HeroSectionPatient";
import "./PatientLandingNew.css";
import CurvedLine from "./CurvedLinePatient";
import Footer from "./footer";

const PatientLandingNew = () => {
  const handleRedirect = () => {
    window.open("https://neuro42.ai/", "_blank");
  };

  return (
    <div className="main-page">
      <NavBarNew />
      <HeroSectionPatient />

      <div className="shapes">
        <div className="shape rectangle"></div>
        <div className="shape circle"></div>
      </div>

      <div className="styled-line-main">
        <div className="line1-main"></div>
        <div className="line2-main"></div>
        <div className="line3-main"></div>
      </div>

      <div className="info-section">
        <div className="info-content">
          <h2>Seamless Access to Your MRI Insights</h2>
          <p>
            Experience the dual advantages of precision and portability with our
            cutting-edge Portal MRI technology. Enjoy faster scans and clearer
            images, providing both patients and physicians with comfort,
            convenience, and confidence in diagnoses and treatment plans. Step
            into the future of MRI innovation with us.
          </p>
          <div className="second-section-learn-more">
            <button className="learn-more-button" onClick={handleRedirect}>
              Learn More
            </button>
          </div>
        </div>
        {/* <div class="info-image">
          <img src={logo} alt="MRI Device" />
        </div> */}
      </div>

      <div className="shapes-2">
        <div className="rectangle2">
          <div className="telehealth-header">
            <div className="styled-line-TeleHealth">
              <div className="line1-TeleHealth"></div>
              <div className="line2-TeleHealth"></div>
              <div className="line3-TeleHealth"></div>
            </div>
            <h2>Health Portal Benefits</h2>
            <p>
              Transform the way you deliver care with our comprehensive health
              portal. Experience the future of healthcare today.
            </p>
          </div>
        </div>
      </div>
      <div className="curved-line-container">
        <CurvedLine />
      </div>
      <Footer />
    </div>
  );
};

export default PatientLandingNew;
